import { useContext } from 'react';
import { useStyletron } from 'baseui';
import { Block } from 'baseui/block';
import { KIND as ButtonKind } from 'baseui/button';
import { Modal, ModalBody, ModalButton, ModalFooter, ModalHeader, SIZE } from 'baseui/modal';
import { ProjectContext } from '../../ProjectApp/context';
import { AdjustmentProvider } from './AdjustmentContext';
import AdjustmentForm from './AdjustmentForm';
import AdjustmentTable from './AdjustmentTable';
const AdjustmentModal = ({
  hideModal,
  isVisible
}) => {
  const {
    projectId
  } = useContext(ProjectContext);
  const [css] = useStyletron();
  const handleClose = () => {
    hideModal();
  };
  return <Modal size={SIZE.auto} isOpen={isVisible} onClose={handleClose} closeable animate>
      <ModalHeader>Project {projectId()} Adjustments</ModalHeader>

      <ModalBody>
        <AdjustmentProvider>
          <AdjustmentForm hideModal={hideModal} />
          <AdjustmentTable />
        </AdjustmentProvider>
      </ModalBody>

      <ModalFooter>
        <div className={css({
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center'
      })}>
          <Block>
            * Non-admins will be shown the total price, including all
            adjustments.
          </Block>
          <ModalButton data-testid="adjustments-close-button" onClick={handleClose} kind={ButtonKind.tertiary}>
            Close
          </ModalButton>
        </div>
      </ModalFooter>
    </Modal>;
};
export default AdjustmentModal;